import { BaseResourceModel } from '../../models/base-resource.model';
import { Liquidacao } from './liquidacao.model';

// tslint:disable: variable-name

export class LiquidacaoIsencaoReinf extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo?: number,
        public valor_isento?: number,
        public descricao?: string,
        public data_laudo?: string,
        public liquidacao?: Liquidacao,
    ) {
        super();
    }

    static converteJson(json: any): LiquidacaoIsencaoReinf {
        return Object.assign(new LiquidacaoIsencaoReinf(), json);
    }
}
